<template>
	<button type="button" class="btn btn-primary btn-xs" @click="showNewForm" v-show="!showNewModal">New Note</button>
	<div class="panel panel-default" v-show="showNewModal">
		<div class="panel-heading">
			<h5 class="no-margin">New Note</h5>
		</div>
		<div class="panel-body">
			<div class="alert alert-danger" v-if="newNoteErrors.length > 0">
				There were problems with your submission:
				<ul>
					<li v-for="(error, idx) in newNoteErrors" :key="idx">
						{{error}}
					</li>
				</ul>

			</div>
			<div class="form-group">
				<label for="new-content">Content</label>
				<textarea v-model="newNote.content" class="form-control" id="new-content"></textarea>				
			</div>

			<div class="form-group">
				<label for="create_user_id">User</label>
				<select v-model="newNote.user_id" id="create_user_id" class="form-control">
					<option v-for="user in computedUsers" :value="user.id" :key="user.id">
						{{ user.name }}
					</option>
				</select>
			</div>

			<div class="form-group">
				<label for="create_note_type_id">Type</label>
				<select v-model="newNote.note_type_id" id="create_note_type_id" class="form-control">
					<option v-for="type in [{id: 1, name: 'Info'}, {id: 2, name: 'Alert'}]" :value="type.id" :key="type.id">
						{{ type.name }}
					</option>
				</select>
			</div>
		</div>

		<div class="panel-footer">
			<button type="button" @click="hideNewForm" class="btn btn-default">Cancel</button>
			<button type="button" @click="saveNew()" class="btn btn-primary">Save</button>
		</div>
	</div>
	<ul class="list-unstyled" style="margin-top: 1rem;">
		<li v-for="(note, idx) in notes" :key="idx">
			<note-item :note="notes[idx]" @changed="getNotes"></note-item>
		</li>				
	</ul>
</template>

<script setup>
	import NoteItem from './NoteItem.vue';
	import Modal from '../Modal.vue';
	import { ref, onMounted, computed, unref } from 'vue'

	const props = defineProps(['participantId'])

	let notes = ref([])
	let showNewModal = ref(false)
	let confirmDeleteModal = ref(true)
	let users = ref([])
	let newNote = ref({})
	let newNoteErrors = ref([])

	function showNewForm() {
		newNoteErrors.value = [];
		showNewModal.value = true;
	}

	function hideNewForm() {
		initNewNote();
		showNewModal.value = false;
	}

	function initNewNote() {
		newNote.value = {
			content: '',
			user_id: null,
			participant_id: props.participantId,
			note_type_id: 1
		}
	}

	function getNotes() {
		axios.get('/api/notes?participant_id='+props.participantId+'&with=user')
			.then(function(response){
				notes.value = response.data;
			}.bind(this))
			.catch(function (error) {
				alert('There was a problem retrieving the participants notes');
			}.bind(this));
	}

	function noteIsValid() {
		newNoteErrors.value = [];
		if (!newNote.value.content) {
			newNoteErrors.value.push('The note must have content.');
		}
		if (!newNote.value.user_id) {
			newNoteErrors.value.push('The note must have a user.');
		}
		
		if (newNoteErrors.value.length > 0) {
			return false;
		}
		newNoteErrors.value = [];
		return true;
	}

	function saveNew() {
		if (!noteIsValid()) {
			return;
		}
		axios.post('/api/notes', newNote.value)
			.then(function (response) {
				notes.value.push(response.data);
				showNewModal.value = false;
				initNewNote();
			}.bind(this))
			.catch(function (error) {
				alert('There was an error saving the new note.');
			});
	}

	const computedUsers = computed(() => {
		return unref(users)
			.sort(function(a, b) {
				const firstNameComparison = a.first_name.localeCompare(b.first_name);
				return b.is_active - a.is_active || firstNameComparison;
			})
			.map(function (user) {
				let userStatus = user.is_active ? '' : '(inactive)';
				return {
					id: user.id,
					name: user.first_name+' '+user.last_name+' '+userStatus,
				};
			});
	});
	
	onMounted(() => {
		getNotes();
		initNewNote();
		axios.get('/api/users')
			.then(function(response) {
				users.value = response.data;
			}.bind(this))
			.catch(function (error) {
				alert('There was a problem retrieving users for the notes form');
			}) 
	})
</script>